import styled from 'styled-components';

export const TooltipContainer = styled.div`
  background: white;
  padding: 12px;
  border-radius: 7px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);

  width: clamp(260px, 90vw, 320px);
  max-width: 90vw;
  box-sizing: border-box;

  z-index: 10003;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: auto;

  p {
    font-family: IBM Plex Sans;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.2rem;
    color: #4B464F;
    margin: 0;
    text-align: left;

    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  @media (max-width: 480px) {
    top: 50px;
    padding: 16px;
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 8px;
  }

  .tip-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .back-btn {
    cursor: pointer;
    font-size: 18px;
    color: #7B7382;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 4px;
    &:hover {
      background: #f0f0f0;
    }
  }

  .tip-text {
    font-family: IBM Plex Sans;
    font-weight: 600;
    font-size: 13px;
    color: #7B7382;
  }

  .main-actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  button {
    background: #7200E0;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 20px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;

    &:hover {
      background: #5e00b8;
    }
  }
  
  .next-btn {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .subtext {
    font-family: IBM Plex Sans;
    font-weight: 600;
    font-size: 13px;
    color: #7B7382;
    cursor: pointer;
    margin: 0;
  }
`;
